// Copyright ©2026 Hitachi High-Tech Corporation All Rights Reserved.
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatTabsModule } from '@angular/material/tabs';
import { MatButtonModule } from '@angular/material/button';
import { BehaviorSubject } from 'rxjs';
import { Analysis } from '../../../interfaces/analysis';
import { HceStatsViewMoleculeComponent } from "./molecule/hce-stats-view-molecule.component"; 
import { HceStatsViewAssemblyComponent } from "./assembly/hce-stats-view-assembly.component"; 
import { HceStatsViewSvComponent } from "./sv/hce-stats-view-sv.component"; 
import { SvResponse } from '../../../interfaces/hce/hce-sv';
import { RefsNameMapping } from '../../../interfaces/hce/hce-stats';

export enum ViewMode {
  MOLECULE = 'molecule',
  ASSEMBLY = 'assembly',
  SV = 'sv',
}

@Component({
  selector: 'app-hce-stats-view',
  standalone: true,
  imports: [
    CommonModule,
    MatTabsModule,
    HceStatsViewMoleculeComponent,
    HceStatsViewAssemblyComponent,
    HceStatsViewSvComponent,
    MatButtonModule, // Required for the display style of the mat-button.
  ],
  templateUrl: './hce-stats-view.component.html',
  styleUrl: './hce-stats-view.component.css',
})
export class HceStatsViewComponent {
  @Input() analysis!: Analysis | null;
  @Input() sv?: SvResponse;
  @Input() refNameMap?: RefsNameMapping;
  @Output() svStatsCellFilter = new EventEmitter<{
    chr?: string | number;
    svType?: string;
  }>();
  @Output() assemblyStatsCellFilter = new EventEmitter<{
    chr?: string | number;
  }>();

  // tabs
  // View mode
  private viewModeSubject = new BehaviorSubject<ViewMode>(ViewMode.MOLECULE);
  viewMode$ = this.viewModeSubject.asObservable();
  ViewMode = ViewMode; // Expose enum to template
  selected = ViewMode.MOLECULE;

  setViewMode(mode: ViewMode): void {
    this.viewModeSubject.next(mode);
    this.selected = mode;
  }
  
  onSvStatsCellFilter(e: { chr?: string | number; svType?: string }) {
    this.svStatsCellFilter.emit(e);
  }

  onAssemblyStatsCellFilter(e: { chr?: string | number }) {
    this.assemblyStatsCellFilter.emit(e);
  }

}
